import { connect } from 'react-redux'
import {
  compose, lifecycle, withState, withHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import DashboardView from 'components/pages/dashboard'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('detail', 'setDetail', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withHandlers({

  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Dasbor',
        activePage: 'dashboard',
        activeSubPage: 'dashboard',
      })
    },
  }),
)(DashboardView)
